import { Component, OnInit, AfterContentChecked } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { AppConfigService } from './app-config.service';
import { DataViewModule } from 'primeng/dataview';
import { AccordionModule } from 'primeng/accordion';
import { SelectModule } from 'primeng/select';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { CalendarModule } from 'primeng/calendar';
import { DomSanitizer } from '@angular/platform-browser';

// declare all javascript variables/functions defined elsewhere
declare var $;

@Component({
	selector: 'system-reports-component',
	templateUrl: 'system-reports.component.html',
	styleUrls: ['system-reports.component.css']
})
export class SystemReportsComponent implements OnInit, AfterContentChecked {

	private http: HttpClient;
	private configService: ConfigService;
	private appConfigService: AppConfigService;
	systemReports: any[] = [];
	windowWidth = '100%';
	// CurrentURL may actually be unnecessary.  If allowing more than 1 tab open at a time becomes
	// desirable, consider removing currentURL and moving "fullLink" directly into systemReports.
	currentURL = {};
	selectedDisplayPeriod = '1day';
	displayPeriodOptions;
	endDate;
	startDate;
	maxDate;  // end of day today
	ipAddress;

	constructor(appConfigService: AppConfigService, configService: ConfigService, http: HttpClient, public sanitizer: DomSanitizer) {
		console.log('in system-reports constructor');
		this.configService = configService;
		this.http = http;
		this.appConfigService = appConfigService;
		this.parseDataFile();
	}

	ngOnInit() {
		this.displayPeriodOptions = [
			{label: '1 day', value: '1day'},
			{label: '3 days', value: '3days'},
			{label: '5 days', value: '5days'},
			{label: '7 days', value: '7days'},
			{label: '30 days', value: '30days'},
			{label: '60 days', value: '60days'},
			{label: '90 days', value: '90days'},
			{label: '1 year', value: '1year'}
		];

		// Set endDate to current day
		const today = new Date();
		// Set the default start and end date.
		// p-calendar rejects a time including seconds.
		// this.endDate = mmString + mm + '/' + ddString + dd + '/' + yyyy + ' ' + HH + ':' + MM;
		this.endDate = this.convertDateToString ( today, true, true, false);
		console.log( this.endDate );

		// set start date to today at 00:00:00 - this seems to mimic NovaStar's default
		this.startDate = this.convertDateToString ( today, false, false, false);
		this.startDate = this.startDate + ' 00:00';
		// this.startDate = mmString + mm + '/' + ddString + dd + '/' + yyyy + ' ' + '00:00';

		// set max date
		this.maxDate = today;
		this.maxDate.setHours(23);

		const ipAddressEnd = this.configService.systemConfiguration.OperatorInterface.baseDir.indexOf('/', 7);
		this.ipAddress = this.configService.systemConfiguration.DemoMode == true ?
			this.configService.systemConfiguration.OperatorInterface.baseDir.slice(0, ipAddressEnd + 1) :
			this.appConfigService.setTrailingSlash(this.configService.systemConfiguration.NovaStarServerIP);
	}

	ngAfterContentChecked() {
		// const width = $('#container').innerWidth() * .80;
		// this.windowWidth = width;
	}

	// Return a string of length 2 representing the input value
	// e.g. 3 returns "03"; 12 returns "12"
	padNumber( value ): string {
		if ( value < 10 ) {
			return '0' + value;
		} else {
			return '' + value;
		}
	}
	// Convert a date object to a string.  includeHH, includeMM, and includeSS indicate whether or not to include the
	// hour, minute, and second in the string, e.g. 03/15/2018 07:21 is 7:20 AM on March 15, 2018.
	convertDateToString ( dateToConvert, includeHH, includeMM, includeSS ) {
		const dd = dateToConvert.getDate();
		const mm = dateToConvert.getMonth() + 1;
		const yyyy = dateToConvert.getFullYear();
		const HH = dateToConvert.getHours();
		const MM = dateToConvert.getMinutes();
		const SS = dateToConvert.getSeconds(); // p-calendar rejects seconds so don't use.
		const ddString = this.padNumber(dd);
		const mmString = this.padNumber(mm);
		let HHString = this.padNumber(HH);
		let MMString = this.padNumber(MM);
		let SSString = this.padNumber(SS);

		if ( includeHH === true ) { HHString = ' ' + HHString; } else { HHString = ''; }
		if ( includeHH === true && includeMM === true ) { MMString = ':' + MMString; } else { MMString = ''; }
		if ( includeHH === true && includeMM === true && includeSS === true ) { SSString = ':' + SSString; } else { SSString = ''; }
		return mmString + '/' + ddString + '/' + yyyy + HHString + MMString + SSString;
	}

	// Parse the system dashboard configuration file.  Fill systemReports.
	// Responds to DemoMode true (reads static files) or false (makes calls to data web services).
	// Format includes following (note the %variable% ability to substitute parameters from the associated report/plot files):
	// {
	// 	"systemReports": [ {
	// ....."linkName": "System Plots",
	// ....."link": "NovaStar5/plotData.do",
	// ....."links": [
	// .........{ "url": "plots", "reportItem": "plots", "label": "%name%", "link": "NovaStar5/plotDataDisplay.do?plotId=%id%&action=view"}
	// .....],
	// ....."image": "plotData.png"
	//  }
	// 	]
	// }
	parseDataFile () {
		console.log('In systemReports.parseDataFile.');
		const self = this;

		const uri = this.configService.baseDir + 'system/systemReports.json?nocache=' + (new Date()).getTime();
		console.log('Reading configuration file for reports: ', uri);
		this.http.get(this.configService.baseDir + 'system/systemReports.json?nocache=' + (new Date()).getTime()).subscribe ( (systemReportConfig) => {
			console.log(systemReportConfig);

				// first, get system reports configuration json file content
				// self.systemReports = systemReports.systemReports;
				systemReportConfig['systemReports'].forEach(function(item) {
					let report: any;
					report = {
						image: self.configService.baseDir + 'system/' + item['image'],
						link: self.ipAddress + item['link'],
						linkName: item['linkName']
					};
					// console.log(item);
					// these are for itemized system dashboard elements
					if ( item.hasOwnProperty('links')) {
						const numTypes = item.links.length;
						for (let i = 0; i < numTypes; i++) {
							// handle if dates should be specified
							let specifyDates = true;
							if ( item.links[i].hasOwnProperty('specifyDates')) {
								specifyDates = item.links[i]['specifyDates'];
							}

							// Check if a report or other file needs to be read
							if ( item.links[i].hasOwnProperty('url')) {
								// First grab information from the system reports configuration file for each desired link
								const configurationUrl = item.links[i].url;  // this is the filename or the url to dws, perhaps "plots"
								const configurationReportItem = item.links[i].reportItem; // element from the report to grab, perhaps "plots"
								const configurationLabel = item.links[i].label;	// perhaps %name%
								const configurationLink = item.links[i].link;  // perhaps NovaStar5/plotDataDisplay.do?plotId=%id%&action=view

								self.getReportRequest(configurationUrl).then (( reportContents ) => {
									// console.log(reportContents);
									// console.log(self.systemReports);

									// use content of the report
									const reportContentsLinks = reportContents[configurationReportItem];
									const linksArray: any[] = [];
									reportContentsLinks.forEach(function(reportItem) {
										// create a temporary string which is a copy of the label in the system report configuration file
										const finalLabel = self.replaceStrings ( configurationLabel, reportItem );
										const finalLink = self.replaceStrings ( configurationLink, reportItem );
										const currentLinks = {
											link: self.ipAddress + finalLink,
											label: finalLabel,
											specifyDates: specifyDates
										};
										// console.log('Adding ', currentLinks);
										linksArray.push(currentLinks);
									});
									report['links'] = linksArray;

									// default values for currentURL
									self.currentURL[report.linkName] = {};
									if ( linksArray.length > 0 ) {
										self.currentURL[report.linkName].linkInfo = linksArray[0];
										self.currentURL[report.linkName].fullLink = linksArray[0].link;
									}
									self.systemReports = [...self.systemReports, report];
									console.log(self.systemReports);
								});
							} else {
								const links = item.links;
								const linksArray: any[] = [];
								links.forEach(function(item2) {
									const currentLinks = {
										link: self.ipAddress + item2['link'],
										label: item2['label'],
										specifyDates: specifyDates
									};
									linksArray.push(currentLinks);
								});
								report['links'] = linksArray;

								// default values for currentURL
								self.currentURL[report.linkName] = {};
								if ( linksArray.length > 0 ) {
									self.currentURL[report.linkName].linkInfo = linksArray[0];
									self.currentURL[report.linkName].fullLink = linksArray[0].link;
								}
								self.systemReports=[...self.systemReports, report];
							}
						}
					}
			});
		});
	}

	// replaceStrings take a string argument with unknown quantities of %variable% and replaces those with the valueof that variable.
	// For instance "This string %may% contain variables." and the object o={"first": "blah", "may": "does"}
	// returns "This string does contain variables."
	// Can handle any number of variables though so it is recursive.
	replaceStrings (codedString, keyObj) {
		// console.log( 'Called replaceStrings on ' + codedString );
		const firstIndexOf = codedString.indexOf('%');
		if ( firstIndexOf === -1 ) {
			// console.log('Returning ' + codedString);
			return codedString;
		} else {
			const secondIndexOf = codedString.indexOf('%', firstIndexOf + 1);
			const varToReplace = codedString.substring(firstIndexOf, secondIndexOf + 1);
			const key = varToReplace.replace(/%/g, '');
			codedString = codedString.replace(varToReplace, keyObj[key]);
			return this.replaceStrings(codedString, keyObj);
		}
	}

	// Every report can specify a start date and end date OR a display period and end date.
	// This routine currently assumes the url already contains a "?" because the returned
	// string is "&...." to be appended.  Should correct.
	buildTimeString () {
		let startDate = this.startDate;
		let endDate = this.endDate;
		let startDateString = '';
		let displayPeriodString = '';
		let endDateString = '';
		// startDate and endDate are initially strings but once a user has clickd the calendar icon and selected
		// a date through the primeng calendar tool, they become date objects.
		// console.log(typeof(this.startDate));
		if ( typeof(this.startDate) === 'object') {
			startDate = this.convertDateToString( this.startDate, true, true, false );
		}
		if ( typeof(this.endDate) === 'object') {
			endDate = this.convertDateToString( this.endDate, true, true, false );
		}

		if ( $('#startDate').prop('checked')) {
			startDateString = '&startTime=' + startDate;
		} else if ( $('#displayPeriodOption').prop('checked')) {
			displayPeriodString = '&displayPeriod=' + this.selectedDisplayPeriod;
		}
		endDateString = '&endTime=' + endDate;

		return startDateString + displayPeriodString + endDateString;
	}

	printAddOn ( ) {
		console.log(this.buildTimeString());
	}

	// url is the base url to be appended to
	// addition should be in the format "&thingToAdd"
	appendToURL ( url, addition ) {
		if ( url.includes('?')) {
			return url + addition;
		}
		return ( url + addition.replace('&', '?'));
	}

	refreshDates() {
		const builtTimeString = this.buildTimeString();
		const keys = Object.keys( this.currentURL );
		keys.forEach(currentKey => {
			const timeString = this.currentURL[currentKey].linkInfo.specifyDates === true ? builtTimeString : '';
			// this.currentURL[currentKey].fullLink = this.currentURL[currentKey].linkInfo.link + timeString;
			this.currentURL[currentKey].fullLink = this.appendToURL( this.currentURL[currentKey].linkInfo.link, timeString);
		}, this );
		console.log(this.currentURL);
	}

	// Every time an accordion tab is opened, the report/plot for that tab is retrieved and saved to
	// currentURL under the name of that set of links.
	reportOpened(reportEvent, reportList) {
		// console.log(report);
		const timeString = reportList.links[reportEvent.index].specifyDates === true ? this.buildTimeString() : '';
		this.currentURL[reportList.linkName].linkInfo = reportList.links[reportEvent.index];
		// this.currentURL[reportList.linkName].fullLink = reportList.links[reportEvent.index].link + timeString;
		this.currentURL[reportList.linkName].fullLink = this.appendToURL ( reportList.links[reportEvent.index].link, timeString );
		console.log(this.currentURL);
	}

	// Given a report request, either reads the file if in demoMode or calls data web services if not.
	// Returns a Promise, which when fulfilled, resolves to the json contents of the requestUri.
	getReportRequest (requestUri) {
		const self = this;
		return new Promise(function(resolve, reject) {

		const requestReport = new XMLHttpRequest();
		requestReport.onload = function ( ) {
			if ( requestReport.readyState === requestReport.DONE ) {
				if ( requestReport.status === 200 ) {

					// first, get json file content
					const reportContents = JSON.parse(requestReport.responseText);
					resolve(reportContents);
				} else {	// request status wasn't 200
					console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all stations was UNSUCCESSFUL.');
					reject(Error(requestReport.statusText));
				}
			}
		};

		const uri = self.configService.systemConfiguration.DemoMode ?
					self.configService.baseDir + 'system/' + requestUri + '.json?nocache=' + (new Date()).getTime() :
					self.configService.systemConfiguration.WebServices.dataIP + '/' +
					self.configService.systemConfiguration.WebServices.dataRootURI + '/' + requestUri ;
		console.log(uri);

		requestReport.open('get', uri, true );
		console.log('[' + new Date().toLocaleTimeString() + '] Attempting to read ' + uri + ' for NovaStar report.');
		requestReport.send();
		});
	}
}
